import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

import StorageDisclosureRow from './StorageDisclosureRow'

import Locale from './locale'
import Styles from './styles.scss'


export default function StorageDisclosureTable({ storageDisclosures }) {
  return (
    <table className={ Styles.root }>
      <thead className={ Styles.thead }>
        <tr>
          <th className={ Styles.th }>
            <FormattedMessage
              { ...Locale.domain }
            />
          </th>
          <th className={ Styles.th }>
            <FormattedMessage
              { ...Locale.type }
            />
          </th>
          <th className={ Styles.th }>
            <FormattedMessage
              { ...Locale.identifier }
            />
          </th>
          <th className={ Styles.th }>
            <FormattedMessage
              { ...Locale.maxAge }
            />
          </th>
          <th className={ Styles.th }>
            <FormattedMessage
              { ...Locale.description }
            />
          </th>
          <th className={ Styles.th }>
            <FormattedMessage
              { ...Locale.optOut }
            />
          </th>
          <th className={ Styles.th }>
            <FormattedMessage
              { ...Locale.specialPurposes }
            />
          </th>
        </tr>
      </thead>
      <tbody>
        {
          renderRows(storageDisclosures)
        }
      </tbody>
    </table>
  )
}

StorageDisclosureTable.propTypes = {
  storageDisclosures: PropTypes.arrayOf(
    PropTypes.shape(StorageDisclosureRow.propTypes)
  ),
}

function renderRows(storageDisclosures) {
  return storageDisclosures.map(({ description, domains, identifier, maxAgeSeconds, optOut, specialPurposes, type: storageType }) => (
    <StorageDisclosureRow
      description={ description }
      domains={ domains }
      identifier={ identifier }
      key={ identifier }
      maxAgeSeconds={ maxAgeSeconds }
      optOut={ optOut }
      specialPurposes={ specialPurposes }
      storageType={ storageType }
    />
  ))
}
